import {
  SNP_ENCODER,
  SNP_JUMPLED,
  isEmpty
} from "../constants/constant";

class utilities {


  getRandomTwoDigitNumber() {
    return Math.floor(Math.random() * 90) + 10;
  }

  getRandomBetween3AndMax(max) {
    if (max < 3) {
      throw new Error("Max must be at least 3");
    }
    return Math.floor(Math.random() * (max - 3 + 1)) + 3;
  }

  countDigits(n) {
    if (n === 0) return 1;
    return Math.floor(Math.log10(Math.abs(n))) + 1;
  }

  extractLastNDigits(s) {
    if (!s || s.length < 2) return ["", 0];

    const countChar = s[0];
    if (!/^[1-9]$/.test(countChar)) return ["", 0];

    const count = parseInt(countChar, 10);
    const body = s.slice(1);

    if (body.length < count) return ["", 0];

    const lastPart = body.slice(-count);
    if (!/^\d+$/.test(lastPart)) return ["", 0];

    const remaining = body.slice(0, -count);
    const removedNumber = parseInt(lastPart, 10);

    return [remaining, removedNumber];
  }

  jumbleString(input) {
    const level = input.length / SNP_JUMPLED;
    //printDebugLog("jumbleString",SNP_JUMPLED);
    let parts = [input.substring(0, level), input.substring(level)];
    return (
      parts[0].split("").reverse().join("") +
      parts[1].split("").reverse().join("")
    );
  }
  encode(input) {
    input = this.jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
      let c = input.charCodeAt(index) + Number(SNP_ENCODER);
      word = word + String.fromCharCode(c);
    }
    return word;
  }
  decode(input) {
    if (isEmpty(input)) return input;
    let org = "";
    for (let index = 0; index < input.length; index++) {
      let c = input.charCodeAt(index) - Number(SNP_ENCODER);
      org = org + String.fromCharCode(c);
    }
    org = this.jumbleString(org);
    return org;
  }

  encodeString(input) {
    const digit = this.getRandomBetween3AndMax(this.getRandomTwoDigitNumber())
    input = this.jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
      const c = input.charCodeAt(index) + digit;
      word = word + String.fromCharCode(c);
    }
    word = this.countDigits(digit) + word + digit;
    // const decoded = decodeWithDigit(word);
    // printDebugLog("encodeWithDigit", `Encoded: ${input} with digit: ${digit} to ${word} & decoded back to: ${decoded}`);
    return word;
  }
  decodeString(input) {
    if (isEmpty(input)) return input;
    const resArr = this.extractLastNDigits(input);
    input = resArr[0];
    const digit = resArr[1];
    let org = "";
    if (digit > 0) {
      for (let index = 0; index < input.length; index++) {
        const c = input.charCodeAt(index) - digit;
        org = org + String.fromCharCode(c);
      }
      org = this.jumbleString(org);
    }
    return org;
  }
}

export default new utilities();
